/* eslint-disable camelcase */
import axios from 'axios';
import ApiEndpoints from '../../const/ApiEndpoints';

const BASE_URL = ApiEndpoints.MODULE_BASE_URL.CONSOLE;
/**
 * @module useWorker
 * @description A custom React Hook for managing worker pods in a project.
 * @returns {Object} - Returns an object containing methods for fetching worker pod information.
 * @example
 * const { fetchPods } = useWorker();
 */
export default function useWorker() {
  /**
   * Fetches a list of worker pods for a specific project.
   * @function
   * @returns {Promise<import('axios').AxiosResponse>} - A promise that resolves with the response containing worker pod information.
   * @throws {AxiosError} - If an error occurs during the API request.
   */
  const fetchPods = (project_id, pageSize, pageIndex, sortField, sortOrder) => {
    return axios
      .get(BASE_URL + ApiEndpoints.WORKER.WORKER_LIST, {
        params: {
          ...project_id,
          ...(pageIndex || pageIndex === 0
            ? { page_index: pageIndex + 1 }
            : {}),
          ...(pageSize ? { page_size: pageSize } : {}),
          ...(sortField ? { sort_field: sortField } : {}),
          ...(sortOrder ? { sort_order: sortOrder } : {}),
        },
        loader: true,
      })
      .then(
        (res) => {
          return res;
        },
        (error) => {
          throw error;
        }
      );
  };

  const fetchWorkerMetrics = (id, hideLoaderOnRequest) => {
    return axios
      .get(BASE_URL + ApiEndpoints.WORKER.FETCH_WORKERS_METRICS, {
        params: { id },
        loader: !hideLoaderOnRequest,
      })
      .then(
        (res) => res,
        (error) => {
          throw error;
        }
      );
  };

  const derigisterWorker = (id) => {
    return axios
      .delete(BASE_URL + ApiEndpoints.WORKER.DEREGISTER_WORKER, {
        params: { id },
      })
      .then(
        (res) => res,
        (error) => {
          throw error;
        }
      );
  };

  const fetchRemoteExecutables = (id) => {
    return axios
      .get(BASE_URL + ApiEndpoints.WORKER.REMOTE_EXECUTABLES, {
        params: { id },
      })
      .then(
        (res) => res,
        (error) => {
          throw error;
        }
      );
  };

  const fetchOrchestrationSettings = () => {
    return axios
      .get(BASE_URL + ApiEndpoints.WORKER.ORCHESTRATION_SETTINGS)
      .then(
        (res) => res,
        (error) => {
          throw error;
        }
      );
  };
  const saveOrchestrationSettings = (payload) => {
    return axios
      .post(BASE_URL + ApiEndpoints.WORKER.ORCHESTRATION_SETTINGS, payload)
      .then(
        (res) => res,
        (error) => {
          throw error;
        }
      );
  };

  return {
    fetchPods,
    fetchWorkerMetrics,
    derigisterWorker,
    fetchRemoteExecutables,
    fetchOrchestrationSettings,
    saveOrchestrationSettings,
  };
}
